<template>
  <v-container fluid class="mb-auto">
    <v-slide-y-transition mode="out-in">
      <v-layout class="mt-5" column text-xs-center>
        <blockquote class="mt-5" v-if="$store.state.forEmailVerification">
          <div class="text-center mb20">
          <img :src="navLogo" width="25%" >
          </div>
          <h4 class="text-grey95">A verification email has been sent to your email ID.</h4>
          <a href="/">Click here to login</a>
        </blockquote>

        <blockquote class="mt-5" v-else-if="$store.state.forAdminApproval">
          <div class="text-center mb20">
          <img :src="navLogo" width="25%" >
          </div>
          <h4 class="text-grey95">Thanks for signing up.</h4>
          <h5 class="text-grey95">We have recieved your request for registration.</h5>
          <h5 class="text-grey95">You will soon recieve an email with further instructions.</h5>
          <a href="/">Click here to login</a>
        </blockquote>

        <blockquote class="mt-5" v-else >
          <div class="text-center mb20">
          <img :src="navLogo" width="25%" >
          </div>
          <h4 class="text-grey95">Your password has been set successfully.</h4>
          <a href="/">Click here to login</a>
          <!-- <footer>
            <small>
              <em>&mdash;PLease check your email.</em>
            </small>
          </footer> -->
        </blockquote>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<script>
export default {
  name: 'ForgotPassword',
  data: () => ({
  navLogo: '',
  }),
  computed: {
    
  },
  methods: {
   
  },
  created () {
      this.$store.dispatch('ACTION_DOWNLOAD_LOGO', { directory: 'images', document_type: 'logo.png' }).then(res => {
      if (res) {
        let downloadFile = 'data:image/png;base64,' + res
        this.navLogo = downloadFile
      } else {
        this.navLogo = ''
      }
    })
  }
}
</script>
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
